import { axios } from '@/lib/axios';

export const createFileOrderRow = async ({ timePeriod, organizerId }: { timePeriod: string; organizerId: number }) => {
  return axios.post(`/export/${organizerId}`, null, { params: { timePeriod } });
};
